import type { SettlementRecord, Worker } from "../types";
import { settlementSelectionReady } from "../settlementBankAccount";
import { Button } from "./ui/Button";

/**
 * 고른 것으로 정산 묶음을 만드는 줄. 고르는 자리는 정산 내역 표다.
 */
export function PayrollSelectionBar({ selected, workers, disabled, onRegister, onCreate }: { selected: SettlementRecord[]; workers: Worker[]; disabled: boolean; onRegister: () => void; onCreate: () => void }) {
  const ready = settlementSelectionReady(selected, workers);
  /* 선택 건수와 이체 예정액은 정산 준비 창에서 함께 확인한다. */
  return <div className="payroll-selection-bar">
    <Button size="compact" disabled={disabled} data-testid="open-settlement-register" onClick={onRegister}>정산 항목 추가</Button>
    <div className="payroll-selection-action">
      <Button size="compact" variant="primary" disabled={disabled || !selected.length || !ready}
        onClick={onCreate} data-testid="create-settlement-batch">정산 묶음 만들기</Button>
    </div>
    {!ready && <p role="status">선택한 작업자의 은행 정보를 먼저 확인해 주세요.</p>}
  </div>;
}
